export const APP_STATE_KEY = "_APP_STATE_KEY_";

export const defaultAppState = {
  localSaleId: undefined,
  terminalId: undefined,
  siteId: undefined,
  initialized: true,
};
